export default __webpack_public_path__ + "static/media/pritchard-logo.7e8a930e.png";